module.exports = __webpack_public_path__ + "img/circle-user-solid.82d1ca66.svg";